// extracted by mini-css-extract-plugin
export default {"box":"BankAmount_box__y9Lxo","title":"BankAmount_title__jXdhc","titleBold":"BankAmount_titleBold__3etTw","balance":"BankAmount_balance__187kL"};